// TEMP STOCK PHOTOS — replace all 5 with real event/celebration photography before launch.
import img1 from '../../../Assets/careers/careerimg1.jpg';
import img2 from '../../../Assets/careers/careerimg2.jpg'
import img3 from '../../../Assets/careers/careerimg3.jpg'
import img4 from '../../../Assets/careers/careerimg4.png'
import img5 from '../../../Assets/careers/careerimg5.jpg'

const bentoPhotos = [
    { image: img4, caption: "Independence Day Celebration" },
  { image: img2, caption: "Bring Kids at Work" },
  { image: img1, caption: "Holi Celebration" },
  { image: img3, caption: "International Men's Day"},
  
  { image: img5, caption: "Women's Day" },

];


export default function TeamEvents() {
  return (
    <section className="py-10 lg:py-12">
      <div className="containers-min mx-auto px-4 py-8">
        <div className="text-center mb-10">
          {/* <p className="section-eyebrow mb-2">Beyond The Desk</p> */}
          <h3 className="text-center font-gilroy">Beyond The Desk</h3>
          <p className=" mt-3 first-letter:md:mt-5 lg:mt-7 max-w-6xl leading-normal sm:leading-9 font-poppins mx-auto">
            Great work deserves a moment to celebrate. From festivals and team gatherings to milestones and everyday wins, we make time to connect, have fun, and celebrate the people behind the work.
          </p>
        </div>
        <div className="events-bento">
          {bentoPhotos.map((p) => (
            <div className="bento-item" key={p.caption}>
              <img
                src={p.image}
                alt={p.caption}
                className="bento-img"
                style={{ objectPosition: p.position || "center" }}
                loading="lazy"
              />
              <div className="bento-caption">{p.caption}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
 
